// An archived board, opened from Archived (Features 1, 20 Oct): as it was, read only, as a shared link draws it,
// with a bar along the top saying when it was archived and a Restore that puts it back in the boards list.

import { Suspense } from "react";
import { Archive, RotateCcw } from "lucide-react";
import { kindOf } from "../../shared/boardKinds";
import type { Board } from "../../shared/types";
import { Canvas } from "../canvas/Canvas";
import { archivedOn, restoreBoard } from "../state/actions";
import { cx } from "../lib/util";
import { KINDS } from "./kinds";

/** The bar along the top: when it was archived, and Restore. */
export function ArchivedBar({ board, phone = false }: { board: Board; phone?: boolean }) {
  return (
    <div className={cx("archived-bar island", phone && "is-phone")} role="status">
      <Archive size={14} aria-hidden />
      <span>Archived on {archivedOn(board.archived ?? Date.now())}</span>
      <span className="archived-bar-dot" aria-hidden>
        ·
      </span>
      <button className="archived-bar-restore" onClick={() => restoreBoard(board.id)}>
        <RotateCcw size={13} aria-hidden /> Restore
      </button>
    </div>
  );
}

/** The board itself, read only: a canvas as a visitor sees it, a typed board through its kind's shared view. */
export function ArchivedBoard({ board }: { board: Board }) {
  const kind = kindOf(board);
  const Shared = KINDS[kind]?.Shared;
  return (
    <>
      {kind === "canvas" ? (
        <Canvas readOnly />
      ) : (
        <div className="shell is-public is-archived" data-kind={kind}>
          {Shared ? (
            <Suspense fallback={null}>
              <Shared board={board} />
            </Suspense>
          ) : (
            <section className="shell-surface shell-not-here">
              <p>{kind === "files" ? `“${board.name}” is archived. Your files are still on your computer; restore the board to open them here.` : `“${board.name}” is archived, kept just as it was. Restore it to open it.`}</p>
            </section>
          )}
        </div>
      )}
      <ArchivedBar board={board} />
    </>
  );
}
